export const getDocument = () => (typeof document !== 'undefined' ? document : undefined);
